import React, {useCallback, useEffect, useState} from "react";
import ButtonSelect from "../Select/ButtonSelect";
import {ItemSelect} from "../Select/ItemSelect";
import {NumberInput} from "../NumberInput";
import {TextInput} from "../TextInput";
import PropTypes from "prop-types";
import {numberWithCommas, sF, sI} from "../../utilities/NumberFormatter";
import {useMediaQuery} from "react-responsive";
import {InputNumber} from "primereact/inputnumber";

// Reuse the exact same styling / color scheme as Invoice rows
import "../Invoice/InvoiceBodyRow.css";

function PurchaseBodyRow(props) {
    const [item, setItem] = useState({id: props.rowItem.itemId, name: props.rowItem.itemName});
    const [qty, setQty] = useState(props.rowItem.quantity || 0);
    const [price, setPrice] = useState(props.rowItem.price || 0.0);
    const [total, setTotal] = useState(props.rowItem.total || 0.0);
    const [comment, setComment] = useState(props.rowItem.comment || "");
    const [disableButton, setDisableButton] = useState(false);
    const isDesktop = useMediaQuery({query: '(min-width: 1024px)'});

    useEffect(() => {
        setTotal(qty * price);
    }, [qty, price]);

    const updateCurrentRow = useCallback(() => {
        props.setUpdateRow({
            id: props.rowItem.id,
            invoiceId: props.rowItem.invoiceId,
            itemId: item.id,
            itemName: item.name,
            quantity: sI(qty),
            price: sF(price),
            total: sF(total),
            comment: comment,
        });
    }, [qty, price, total, comment, props, item.id, item.name]);

    useEffect(() => {
        updateCurrentRow();
    }, [item.name, qty, price, total, comment]);

    return (
        <>
            <tr className="invoice-body-row">
                <td className="invoice-body-row__cell text-center">
                    <ButtonSelect
                        text="+"
                        setButton={props.setAddButton}
                        variant="primary"
                        disable={!props.thisLast || props.isPosted || disableButton}
                    />
                </td>

                <td className="invoice-body-row__cell text-start">
                    <ItemSelect
                        item={item}
                        disable={props.isPosted || props.cid === 0}
                        itemList={props.itemList}
                        setItem={setItem}
                        setLoading={props.setLoading}
                    />
                </td>

                <td className="invoice-body-row__cell text-end align-content-center">
                    <InputNumber
                        value={sI(qty)}
                        onFocus={(e) => e.target.select()}
                        onValueChange={(e) => setQty(sI(e.target.value))}
                        disabled={props.isPosted || item.name === ""}
                        suffix={" pc/s"}
                        max={100000}
                        min={0}
                        size={11}
                        showButtons={true}
                        minFractionDigits={0}
                        className="invoice-body-row__input h-2rem align-text-right text-right"
                    />
                </td>

                <td className="invoice-body-row__cell text-end align-content-center">
                    <InputNumber
                        disabled={!props.priceEnable || props.isPosted || item.name === ""}
                        onFocus={(e) => e.target.select()}
                        value={sF(price)}
                        max={10000000}
                        onValueChange={(e) => setPrice(sF(e.target.value))}
                        minFractionDigits={2}
                        size={16}
                        className="invoice-body-row__input h-2rem"
                    />
                </td>

                <td className="invoice-body-row__cell text-end align-content-center">
                    {numberWithCommas(total)}
                </td>

                {isDesktop && (
                    <td className="invoice-body-row__cell text-start align-content-center">
                        <TextInput
                            value={comment}
                            setValue={setComment}
                            disable={props.isPosted || item.name === ""}
                            placeholder="Comment"
                        />
                    </td>
                )}

                <td className="invoice-body-row__cell text-center align-content-center">
                    <ButtonSelect
                        text="-"
                        setButton={props.setDeleteButton}
                        variant="danger"
                        disable={props.isPosted}
                    />
                </td>
            </tr>
        </>
    );
}

PurchaseBodyRow.propTypes = {
    rowItem: PropTypes.shape({
        id: PropTypes.string,
        invoiceId: PropTypes.number,
        itemName: PropTypes.string,
        itemId: PropTypes.number,
        quantity: PropTypes.number,
        price: PropTypes.number,
        lastPrice: PropTypes.number,
        stock: PropTypes.number,
        total: PropTypes.number,
        comment: PropTypes.string,
    }).isRequired,
    thisLast: PropTypes.bool.isRequired,
    i: PropTypes.number.isRequired,
    setAddButton: PropTypes.func.isRequired,
    setDeleteButton: PropTypes.func.isRequired,
    priceEnable: PropTypes.bool.isRequired,
    setUpdateRow: PropTypes.func.isRequired,
    isPosted: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    cid: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    itemList: PropTypes.array.isRequired,


};

export default PurchaseBodyRow;